module.exports = __webpack_public_path__ + "static/media/shopping-bag.7a1da6a6.svg";